import {FormInput, FormInputDatePicker} from "root/ReactHookForm/FormComponents";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {
    ModalFutureAbsenceSectionsNames
} from "root/s360components/Modals/FutureAbsence/ModalFutureAbsence";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import './FutureAbsenceCreateFragment.scss';
import DropdownAbsenceCode, {getAbsenceCode} from "root/s360components/ReactHookForm/ui/DropdownAbsenceCode";
import {useAbsenceCodesContext} from "root/s360components/Contexts/AbsenceCodes/AbsenceCodesContext";
import {useEffect} from "react";
import {ModalFutureAbsenceModes} from "root/s360components/Modals/FutureAbsence/useModalFutureAbsence";


const FutureAbsenceDeleteFragment = ({sectionName, formErrors, control, register, setValue, selectedAbsenceCode}) =>
{

    const readOnly = true;

    const {absenceCodes, loadingAbsenceCodes} = useAbsenceCodesContext();

    useEffect(() =>
    {
        if (selectedAbsenceCode !== null && loadingAbsenceCodes === false)
        {
            setValue(ModalFutureAbsenceModes.DELETE + '.' + ModalFutureAbsenceSectionsNames.ABS_CODE, getAbsenceCode(selectedAbsenceCode, absenceCodes))
        }
    }, [selectedAbsenceCode, loadingAbsenceCodes])

    return (
        <form className='future-absence-delete-frag'>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <label className='form-label'>Username</label>
                    <FormInput register={register} sectionName={sectionName}
                               name={ModalFutureAbsenceSectionsNames.FULL_NAME} formErrors={formErrors} readOnly={readOnly}/>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <label>Select a reason</label>
                    <DropdownAbsenceCode readOnly={readOnly} absenceCodes={absenceCodes} loadingAbsenceCodes={loadingAbsenceCodes} control={control}
                                         fieldName={sectionName + '.' + ModalFutureAbsenceSectionsNames.ABS_CODE}/>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputDatePicker control={control} sectionName={sectionName}
                                         name={ModalFutureAbsenceSectionsNames.ABS_FROM}
                                         formErrors={formErrors} readOnly={readOnly} label={'From'}/>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputDatePicker control={control} sectionName={sectionName}
                                         name={ModalFutureAbsenceSectionsNames.ABS_TO}
                                         formErrors={formErrors} readOnly={readOnly} label={'To'}/>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <p style={{color: "red", fontWeight: "bold"}}>Are you sure you want to delete this record? This action cannot be undone.</p>
                </BootstrapCol>
            </BootstrapRow>
        </form>
    )
}

export default FutureAbsenceDeleteFragment;